var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgReturns = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M23.5 26.5 22.064 28 18 24l4-4 1.5 1.5-1.801 1.5H32v9H12V15.605L15 12h14l3 3.605V21h-2v-3H14v12h16v-5h-8.301l1.801 1.5ZM21 14h-5l-1.5 2H21v-2Zm7 0h-5v2h6.5L28 14Z",
  fill: "#2D2D2D",
  fillRule: "evenodd"
})));
export default SvgReturns;